
'use strict';
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class UserManagementConstant {

  public static AccessGroupAllowed = [
    { name: 'MYIM_IC', value: 'MYIM - INCIDENT CONTROLLER' },
    { name: 'MYIM_ADMIN', value: 'MYIM - ADMIN (HQ ONLY)' },
    { name: 'MYIM_READONLY', value: 'MYIM - READ ONLY' },
    { name: 'MYIM_ROUTEDIR', value: 'MYIM - ROUTE DIRECTOR' },
    { name: 'MYIM_DELIVERYMGR', value: 'MYIM - DELIVERY MANAGER' },
    { name: 'MYIM_SINCS_ENGINEER', value: 'MYIM - SINCS ENGINEER (LEVEL 1)' },
    { name: 'MYIM_SINCS_APPROVER', value: 'MYIM - SINCS APPROVER (REVIEWER)' },
    { name: 'MYIM_SINCS_MAINTAINER', value: 'MYIM - SINCS MAINTAINER (LEVEL 2)' },
    { name: 'MYIM_SINCS_REVIEWER', value: 'MYIM - SINCS REVIEWER' }
  ];

  public static AccessGroupName = {
    MYIM_READONLY: 'MYIM - READ ONLY',
    MYIM_IC: 'MYIM - INCIDENT CONTROLLER',
    MYIM_SINCS_ENGINEER: 'MYIM - SINCS ENGINEER (LEVEL 1)',
    MYIM_SINCS_APPROVER: 'MYIM - SINCS APPROVER (REVIEWER)',
    MYIM_SINCS_MAINTAINER: 'MYIM - SINCS MAINTAINER (LEVEL 2)',
    MYIM_SINCS_REVIEWER: 'MYIM - SINCS REVIEWER',
    MYIM_ADMIN: 'MYIM - ADMIN (HQ ONLY)',
    MYIM_ROUTE_DIR: 'MYIM - ROUTE DIRECTOR',
    MYIM_DELIVERY_MGR: 'MYIM - DELIVERY MANAGER',
    MYIM_EMAIL_OPT: 'MYIM - EMAIL OPT OUT'
  }

  public static SystemRole = {
    APP_USER_READ_ONLY: 'App User Read Only',
    APP_USER_WRITE_ONLY: 'App User Write Only',
    SYS_ADMIN_READ_ONLY: 'Sys Admin Read Only',
    SYS_ADMIN_WRITE_ONLY: 'Sys Admin Write Only'
  }

  public static ItResources = {
    MYIM_CREATE_FAILURE: 'MYIM Failure',
    MYIM_EDIT_FAILURE: 'MYIM Failure',
    MYIM_CLOSE_FAILURE: 'MYIM Failure',
    MYIM_SINCS: 'MYIM SINCS',
    MYIM_SINCS_REVIEW: 'MYIM SINCS Review',
    MYIM_ADMIN_MENU: 'MYIM Admin menu',
    MYIM_REPORT: 'MYIM Report',
  }

}
